import { useQueryClient } from '@tanstack/react-query';
import { useSaveUserExperienceMutation, useValidateUserExperienceMutation } from '../queries/userExperienceQueries';
import { normalizeNonBFIUserExperienceForApi } from '../utils/normalizeNonBFIUserExperienceForApi';
import { experienceQueryKey } from '../keys/experienceQueryKey';

export function useSaveExperience(experienceId: string | undefined) {
    const queryClient = useQueryClient();
    const saveMutation = useSaveUserExperienceMutation();
    const validateMutation = useValidateUserExperienceMutation();

    const saveExperience = async () => {
        // Retrieve Experience from cache using the same key as field hooks
        const experience = queryClient.getQueryData(experienceQueryKey(experienceId));

        if (!experience) {
            console.error('No experience found in cache');
            return { success: false };
        }

        //Execute Validation
        const isValid = await validateMutation.mutateAsync(experience);
        if (!isValid) {
            return { success: false, reason: 'duplicate-address' };
        }

        //Prepare for Api
        const payload = normalizeNonBFIUserExperienceForApi(experience);

        //Save
        const result = await saveMutation.mutateAsync(payload);

        return result;
    };

    return saveExperience;
}
